"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var iframeWhitelist = [
    'anchor.fm',
    'fast.wistia.com',
    'files.prolaera.com',
    'forms.office.com',
    'pbs.twimg.com',
    'player.vimeo.com',
    'players.brightcove.net',
    'video.tv.adobe.com',
    'web.microsoftstream.com',
    'www.youtube.com'
];
exports.iframeWhitelist = iframeWhitelist;
//# sourceMappingURL=iframeWhitelist.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prolaera/library/dist/iframeWhitelist.js
// module id = 885
// module chunks = 0